module.exports = __webpack_public_path__ + "static/assets/7ff0420418814a493cb3a9fac4c43f7d.jpg";